function officeHourseVisibility() {
    // Get the elements to hide
    const hideElements = document.querySelectorAll(".hide_out_of_hours");
  
    // Get the current date and time
    let now = new Date();
  
    // Uncomment the following lines for testing
    //let testTime = '14:00:00'; // Adjust this time as needed. 14:00 in UK is 09:00 CST
    //now = new Date(now.toDateString() + ' ' + testTime);
    
    const cstNow = new Date(
      now.toLocaleString("en-US", { timeZone: "America/Chicago" })
    );
  
    /* Uncomment the following lines for testing. Alert time in CST */
    //alert(cstNow); 
  
    const cstHour = cstNow.getHours();
    const cstMinutes = cstNow.getMinutes();
    const cstSeconds = cstNow.getSeconds();
  
    const isOfficeHours =
      (cstHour === 8 && cstMinutes === 0 && cstSeconds === 0) ||
      (cstHour > 8 && cstHour < 17);
  
    hideElements.forEach((element) => {
      element.style.display = isOfficeHours ? "flex" : "none";
    });
  }
  
  // Check if there are elements to hide or show before setting the interval
  const hideElements = document.querySelectorAll(".hide_out_of_hours");
  if (hideElements.length > 0) {
    officeHourseVisibility();
    // Then run the function every minute.
    setInterval(officeHourseVisibility, 60000);
  }